import React from "react";
import { Link } from "react-router-dom";
import './footer.css'
import instagram from 'shared/assets/icons/instagram.svg'
import telegram from 'shared/assets/icons/telegram.svg'
import tiktok from 'shared/assets/icons/tiktok.svg'

const Footer = () => {

    const year = new Date().getFullYear();

    return(
        <footer className="footer-main">
            <div className="footer-horizontal">
                <div className="footer-left">
                    <p className="footer-brand">CRYPTOXNFT</p>
                    <p className="footer-copy">Crypto market context, VIP resources, and copy trading access. Educational content only, not financial advice.</p>
                    <div className="footer-left-text">
                        <Link to="/terms&conditions" className="footer-links">Terms and Conditions</Link>
                        <Link to="/risk-disclosure" className="footer-links">Risk Disclosure</Link>
                    </div>
                </div>
                <div className="footer-right" aria-label="Social links">
                    <a 
                    href="https://www.instagram.com/cryptoxnftsignals/?igshid=MjEwN2IyYWYwYw%3D%3D" 
                    target="blank" aria-label="Instagram"><img alt="" src={instagram}/></a>

                    <a href="https://t.me/cryptoxnfts"
                    target="blank" aria-label="Telegram"><img alt="" src={telegram}/></a>

                    <a href="https://www.tiktok.com/@cryptoxnftsignals?_t=8dTzgNUZwkc&_r=1"
                    target="blank" aria-label="TikTok"><img alt="" src={tiktok}/></a>
                </div>
            </div>
            <p className="footer-copyright">© {year} All rights reserved. CRYPTOXNFT</p>
        </footer>
    )
}

export default Footer
